"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// TODO:- write a debug function since the lib DEBUG is not working
var _default = function _default() {
  return function () {};
};

exports.default = _default;